/** A short, human-friendly reference for a report, used in banners and staff panels: "#4F2A". */
export function shortReportRef(id: string): string {
  const hex = id.replace(/[^0-9a-f]/gi, '').slice(0, 4)
  return `#${hex.toUpperCase()}`
}
